export const VIEW_MODE_EDITOR = 'editor';
export const VIEW_MODE_PREVIEW = 'preview';
export const VIEW_MODE_SITE = 'site';
export const VIEW_MODE_DASHBOARD = 'dashboard';
export const VIEW_MODE_VIEWER_SEO = 'viewer-seo';
export const VIEW_MODE_VIEWER = 'viewer';
export const VIEW_MODE_ONBOARDING = 'onboarding';
export const ALL_VIEW_MODES = [
    VIEW_MODE_EDITOR,
    VIEW_MODE_PREVIEW,
    VIEW_MODE_SITE,
    VIEW_MODE_DASHBOARD,
    VIEW_MODE_VIEWER_SEO,
    VIEW_MODE_VIEWER,
    VIEW_MODE_ONBOARDING,
];
//# sourceMappingURL=view-modes.js.map